<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>钱包转冷设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <add-cold></add-cold>
      <cold-list class="page-content"></cold-list>
    </div>
  </div>
</template>

<script>
import './store';
import coldList from './components/list';
import addCold from './components/addCold';

export default {
  name: 'WalletSwitchCold',
  components: {
    coldList,
    addCold
  }
};
</script>

<style lang="less" scoped></style>
